var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3925.9 3608.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: .71px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill: none;\n        stroke: #000;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-3, .cls-5 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 9.07px;\n      }\n\n      .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m2035.19,3213.14c621.06,0,966.32,0,1191.82-225.5,225.5-225.5,225.5-570.76,225.5-1191.82s0-966.32-225.5-1191.82c-225.5-225.5-570.76-225.5-1191.82-225.5s-966.32,0-1191.82,225.5c-225.5,225.5-225.5,570.76-225.5,1191.82s0,966.32,225.5,1191.82c225.5,225.5,570.76,225.5,1191.82,225.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m2035.19,3388.11c698.27,0,1086.44,0,1339.97-253.53,253.53-253.53,253.53-641.71,253.53-1339.97s0-1086.44-253.53-1339.97c-253.53-253.53-641.71-253.53-1339.97-253.53s-1086.44,0-1339.97,253.53c-253.53,253.53-253.53,641.71-253.53,1339.97s0,1086.44,253.53,1339.97c253.53,253.53,641.71,253.53,1339.97,253.53Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_3",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 372.64,
    y1: 2848.14,
    x2: 480,
    y2: 2848.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m978.33,668.81c4.41,6.57,8.82,13.13,13.23,19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1337.59,668.16h-29.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1308.4,689.15h29.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1026.75,
    y1: 673.45,
    x2: 1050.11,
    y2: 673.45
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m913.15,647.59v41.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m960.98,647.69v41.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 893.19,
    y1: 647.59,
    x2: 933.1,
    y2: 647.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1253.97,647.59v41.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1234.02,
    y1: 647.59,
    x2: 1273.93,
    y2: 647.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1308.22,648.11v41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1308.22,647.24h29.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m960.98,647.69h17.35c6.06.48,10.52,5.75,10.09,11.38-.39,5.07-4.66,9.34-10.09,9.74h-15.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1085.89,688.76v-41.11c.78.38,1.93.91,3.32,1.51,6.95,2.98,15.14,6.51,25.1,6.65,12.99.18,22.54-4.4,26.61-6.65,1.16-.54,2.32-1.08,3.49-1.62v41.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1181.34,668.74h15.84c5.43-.39,9.71-4.67,10.09-9.74.43-5.63-4.03-10.9-10.09-11.38h-17.35v41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1020.64,688.73l6.11-16.14c3.3-8.36,6.61-16.73,9.91-25.09,1.32,0,2.65,0,3.97,0,3.09,8.12,6.17,16.27,9.24,24.45,2.1,5.6,4.19,11.19,6.27,16.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m1403.56,659.39c-2.58-7.31-9.33-12.35-17-12.72-7.92-.38-15.31,4.28-18.43,11.65-.87,2.26-2.05,6.24-1.72,11.24.23,3.53,1.13,6.37,1.92,8.31,3.32,6.98,10.55,11.28,18.23,10.84,7.83-.45,14.62-5.74,17-13.25"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3043.22,2965.84c-4.41-6.57-8.82-13.13-13.23-19.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2683.96,2966.49h29.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2713.15,2945.5c-9.67,0-19.35,0-29.02,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 2994.79,
    y1: 2961.2,
    x2: 2971.44,
    y2: 2961.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3108.4,2987.05c0-13.71,0-27.42,0-41.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3060.57,2986.96c0-13.68,0-27.36,0-41.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 3128.36,
    y1: 2987.05,
    x2: 3088.45,
    y2: 2987.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2767.58,2987.05c0-13.71,0-27.42,0-41.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2787.53,
    y1: 2987.05,
    x2: 2747.62,
    y2: 2987.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2713.32,2986.54c0-13.68,0-27.36,0-41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2713.32,2987.41c-9.67,0-19.35,0-29.02,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3060.57,2986.96h-17.35c-6.06-.48-10.52-5.75-10.09-11.38.39-5.07,4.66-9.34,10.09-9.74,5.28,0,10.56,0,15.84,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2935.66,2945.89c0,13.7,0,27.41,0,41.11-.78-.38-1.93-.91-3.32-1.51-6.95-2.98-15.14-6.51-25.1-6.65-12.99-.18-22.54,4.4-26.61,6.65-1.16.54-2.32,1.08-3.49,1.62,0-13.73,0-27.46,0-41.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2840.21,2965.91c-5.28,0-10.56,0-15.84,0-5.43.39-9.71,4.67-10.09,9.74-.43,5.63,4.03,10.9,10.09,11.38h17.35c0-13.68,0-27.36,0-41.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m3000.9,2945.92l-6.11,16.14c-3.3,8.36-6.61,16.73-9.91,25.09-1.32,0-2.65,0-3.97,0-3.09-8.12-6.17-16.27-9.24-24.45-2.1-5.6-4.19-11.19-6.27-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m2617.99,2975.26c2.58,7.31,9.33,12.35,17,12.72,7.92.38,15.31-4.28,18.43-11.65.87-2.26,2.05-6.24,1.72-11.24-.23-3.53-1.13-6.37-1.92-8.31-3.32-6.98-10.55-11.28-18.23-10.84-7.83.45-14.62,5.74-17,13.25"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1721.84,
    cy: 667.09,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 841.38,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 841.38,
    cy: 2411.1,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1422.71,
    cy: 2411.1,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2001.42,
    cy: 2410.59,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2622.76,
    cy: 2411.67,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 3207.91,
    cy: 2411.67,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 847.61,
    cy: 1221.04,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1428.95,
    cy: 1221.04,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2007.65,
    cy: 1220.52,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2628.99,
    cy: 1221.6,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 3214.14,
    cy: 1221.6,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1133.19,
    cy: 2945.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1720.09,
    cy: 2945.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2320.23,
    cy: 2945.31,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1410.4,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2002.76,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2614.07,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 3207.91,
    cy: 1815.72,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2320.55,
    cy: 667.09,
    rx: 36.85,
    ry: 36.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 2921.21,
    cy: 667.09,
    rx: 36.85,
    ry: 36.76
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDesign);
export default __webpack_public_path__ + "static/media/customDesign.27e07a9f5b86b92634c09002835b680e.svg";
export { ForwardRef as ReactComponent };